import { module } from 'modujs';
import { $html } from '../utils/dom'
import { FONT } from '../config';
import { whenReady } from '../utils/fonts';
import { gsap, SplitText } from 'gsap/all'
gsap.registerPlugin(SplitText)

export default class HeroHome extends module {

    static CLASS = {
        EXPERIENCE_HOVER: 'has-experience-hover',
    }

    constructor(m) {
        super(m);

        this.onTitleTimelineCompletedBind = this.onTitleTimelineCompleted.bind(this)

        // UI
        this.$firstLine = this.$('first-line')[0]
        this.$secondLine = this.$('second-line')[0]

        this.events = {
            mouseenter: {
                button: 'buttonMouseEnter',
            },
            mouseleave: {
                button: 'buttonMouseLeave'
            },
        }
    }

    init() {
        if(window.isReduceMotion) return
        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));
    }

    destroy() {
        super.destroy()
    }

    // ==========================================================================
    // Callbacks
    // ==========================================================================
    onFontsLoaded() {
        if(window.isReduceMotion) return
        this.split()
        this.initTimeline()
        requestAnimationFrame(() => {
            this.titleTimeline.play()
        })
    }

    // ==========================================================================
    // Methods
    // ==========================================================================
    split() {
        this.secondLineSplitted = new SplitText(this.$secondLine, {
            type: 'lines, chars',
            linesClass: 'c-split-text_line',
            wordsClass: 'c-split-text_word',
            charsClass: "c-split-text_char",
        })
    }

    initTimeline() {
        this.titleTimeline = gsap.timeline({
            paused: true,
            onComplete: this.onTitleTimelineCompletedBind
        })

        this.titleTimeline.fromTo(
            this.secondLineSplitted.chars,
            {
                y: '100%',
                opacity: 0
            },
            {
                y: '0',
                opacity: 1,
                stagger: {
                    each: 0.02,
                    from: "center",
                },
                duration: 1,
                ease: "power3.out"
            }
        )

        this.titleTimeline.fromTo(
            this.$firstLine,
            {
                opacity: 0
            },
            {
                opacity: 1
            },
            '<+0.5'
        )

    }

    onTitleTimelineCompleted() {
        this.titleTimeline.kill()
    }

    unsplit() {
        this.secondLineSplitted?.revert()
    }

    onInview(args) {
        if(window.isReduceMotion) return
        if (args.way === 'leave') {
            this.titleTimeline?.kill()
            this.unsplit();
        }
    }

    buttonMouseEnter() {
        $html.classList.add(HeroHome.CLASS.EXPERIENCE_HOVER)
    }

    buttonMouseLeave() {
        $html.classList.remove(HeroHome.CLASS.EXPERIENCE_HOVER)
    }
}
